(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-pair-with"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SERIES_NAME = { 'empyrean': 'Fourth Wing', 'acotar': 'ACOTAR', 'throne-of-glass': 'Throne of Glass', 'crescent-city': 'Crescent City', 'shield-of-sparrows': 'Shield of Sparrows', 'dream-harbor': 'Dream Harbor' };
    var ALIAS = { 'trope:werewolves-shifters': ['trope:werewolves', 'trope:shifters'], 'trope:monster-romance': ['trope:monster'], 'trope:grumpy-x-sunshine': ['trope:grumpy-sunshine'] };
    var SKIP_TYPES = ['Event', 'Gift Card', 'Book Club', ''];

    function split(v) { return v ? v.split('|').filter(Boolean) : []; }
    function withPrefix(list, p) { return list.filter(function (t) { return t.indexOf(p + ':') === 0; }); }
    function handle(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function label(t) {
      var v = t.split(':')[1] || t;
      if (t.indexOf('series:') === 0 && SERIES_NAME[v]) return SERIES_NAME[v];
      return v.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    function tropeSlug(v) { return 'trope:' + String(v).toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

    /* Pages after the first load in parallel. */
    function fetchItems(url, pagesMax) {
      function get(n) { return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'page=' + n).then(function (r) { return r.json(); }); }
      return get(1).then(function (j) {
        var last = Math.min(j.pages || 1, pagesMax), rest = [];
        for (var n = 2; n <= last; n++) rest.push(get(n));
        return Promise.all(rest).then(function (more) {
          var items = j.items || [];
          more.forEach(function (m) { items = items.concat(m.items || []); });
          return items;
        });
      });
    }

    /* localStorage for 24h (instant on later pages and visits), refreshed in the background after 10 minutes. */
    function save(key, items) {
      var v = JSON.stringify({ ts: Date.now(), items: items });
      try { localStorage.setItem(key, v); return; } catch (e) {}
      try { Object.keys(localStorage).forEach(function (k) { if (/^rb(Data|Merch|Books):/.test(k)) localStorage.removeItem(k); }); localStorage.setItem(key, v); } catch (e) {}
    }
    function cached(key, loader) {
      var c = null;
      try { c = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
      if (c && c.items && Date.now() - c.ts < 86400000) {
        if (Date.now() - c.ts > 600000) loader().then(function (items) { save(key, items); }).catch(function () {});
        return Promise.resolve(c.items);
      }
      return loader().then(function (items) { save(key, items); return items; });
    }

    function card(item, why, isBook) {
      var a = document.createElement('a');
      a.className = 'rb-pair__card';
      a.href = item.u;
      var img;
      if (item.i) {
        img = document.createElement('img');
        img.src = item.i;
        img.alt = item.t;
        img.loading = 'lazy';
        img.width = 300;
        img.height = isBook ? 450 : 300;
      } else {
        img = document.createElement('span');
      }
      img.className = 'rb-pair__img';
      a.appendChild(img);
      var name = document.createElement('span');
      name.className = 'rb-pair__name';
      name.textContent = isBook ? item.t.split(' by ')[0] : item.t.replace(/\s*\|\s*Fourth Wing$/, '');
      a.appendChild(name);
      var price = document.createElement('span');
      price.className = 'rb-pair__price';
      price.textContent = item.p;
      a.appendChild(price);
      if (why) {
        var w = document.createElement('span');
        w.className = 'rb-pair__why';
        w.textContent = why;
        a.appendChild(w);
      }
      return a;
    }

    function show(box, sub, cards) {
      if (!cards.length) return;
      box.querySelector('.rb-pair__sub').textContent = sub;
      var row = box.querySelector('.rb-pair__row');
      cards.forEach(function (c) { row.appendChild(c); });
      box.hidden = false;
    }

    /* ---------- Book page: matching merch ---------- */
    function merchForBook(box) {
      var tags = split(box.dataset.tags);
      var main = [];
      split(box.dataset.tropes).forEach(function (v) { var k = tropeSlug(v); main.push(k); (ALIAS[k] || []).forEach(function (a) { main.push(a); }); });
      var bSeries = withPrefix(tags, 'series'), bTropes = withPrefix(tags, 'trope'), bGenre = withPrefix(tags, 'genre'), bMood = withPrefix(tags, 'mood');
      var spiceTag = withPrefix(tags, 'spice')[0];
      var spice = spiceTag ? parseInt(spiceTag.split(':')[1], 10) || 0 : 0;
      var young = bGenre.some(function (g) { return /young-adult|childrens/.test(g); });
      var limit = parseInt(box.dataset.limit, 10) || 8;
      var col = box.dataset.collection || 'bookish-merchandise';

      cached('rbMerch:' + col, function () { return fetchItems('/collections/' + col + '?view=rb-merch&sort_by=best-selling', 4); }).then(function (items) {
        var scored = [];
        items.forEach(function (m, rank) {
          if (m.y === 'Book' || SKIP_TYPES.indexOf(m.y || '') > -1) return;
          var g = m.g || [];
          if (young && (g.indexOf('flag:mature') > -1 || g.indexOf('theme:spicy') > -1)) return;
          if (g.indexOf('genre:childrens') > -1 && bGenre.indexOf('genre:childrens') === -1) return;
          var s = 0, why = '';
          var ser = g.filter(function (t) { return bSeries.indexOf(t) > -1; });
          if (ser.length) { s += 100; why = label(ser[0]); }
          var hit = g.filter(function (t) { return main.indexOf(t) > -1; });
          if (hit.length) { s += 20 * hit.length; why = why || label(hit[0]); }
          if (g.some(function (t) { return bGenre.indexOf(t) > -1; })) s += 10;
          var weak = g.filter(function (t) { return t.indexOf('trope:') === 0 && bTropes.indexOf(t) > -1 && main.indexOf(t) === -1; });
          if (weak.length) { s += 3; why = why || label(weak[0]); }
          if (!young) {
            if (bMood.indexOf('mood:dark') > -1 && g.indexOf('style:dark') > -1) s += 4;
            if (spice >= 3 && g.indexOf('theme:spicy') > -1) s += 4;
          }
          if (bMood.indexOf('mood:funny') > -1 && g.indexOf('theme:funny') > -1) s += 4;
          if (!s && (g.indexOf('theme:book-lover') > -1 || g.indexOf('theme:tbr') > -1)) s = 1;
          if (s) scored.push({ m: m, s: s, rank: rank, why: why });
        });
        scored.sort(function (a, b) { return b.s - a.s || a.rank - b.rank; });
        var out = [], perType = {};
        for (var i = 0; i < scored.length && out.length < limit; i++) {
          var ty = scored[i].m.y || 'x';
          if ((perType[ty] || 0) >= 2 && scored.length > limit * 2) continue;
          perType[ty] = (perType[ty] || 0) + 1;
          out.push(scored[i]);
        }
        if (!out.length) return;
        var top = out[0];
        var sub = top.s >= 100 ? 'For fellow ' + top.why + ' readers' : (top.s >= 20 ? 'Gifts that match this book' : 'Little extras for readers');
        show(box, sub, out.map(function (o) { return card(o.m, (top.s >= 100 && o.why === top.why) ? '' : o.why, false); }));
      }).catch(function () {});
    }

    /* ---------- Merch page: matching books ---------- */
    function booksForMerch(box) {
      var tags = split(box.dataset.tags);
      var mature = tags.indexOf('flag:mature') > -1 || tags.indexOf('theme:spicy') > -1;
      var kids = tags.indexOf('genre:childrens') > -1;
      var keys = withPrefix(tags, 'series').concat(withPrefix(tags, 'trope'), withPrefix(tags, 'genre'));
      if (!keys.length) return;
      var limit = parseInt(box.dataset.limit, 10) || 8;
      var out = [], seen = {}, firstWhy = '';

      function num(item) {
        var n = (item.g || []).filter(function (t) { return t.indexOf('series-num:') === 0; })[0];
        return n ? parseFloat(n.split(':')[1]) : 999;
      }
      function base(item) { return item.t.split(' by ')[0].replace(/\s*\(.*?\)\s*/g, '').toLowerCase(); }

      /* start every lookup at once, then use them in order */
      var lookups = keys.slice(0, 6).map(function (key) {
        return cached('rbBooks:' + key, function () {
          return fetchItems('/collections/all/' + handle(key) + '?view=rb-merch&sort_by=best-selling', 1);
        }).catch(function () { return []; });
      });
      function next(i) {
        if (i >= lookups.length || out.length >= limit) return Promise.resolve();
        var key = keys[i];
        return lookups[i].then(function (items) {
          var books = items.filter(function (b) {
            if (b.y !== 'Book') return false;
            var g = b.g || [];
            if (kids) return g.indexOf('genre:childrens') > -1;
            if (g.indexOf('genre:childrens') > -1) return false;
            if (mature && g.some(function (t) { return /young-adult/.test(t); })) return false;
            return true;
          });
          if (key.indexOf('series:') === 0) books.sort(function (a, b) { return num(a) - num(b); });
          books.forEach(function (b) {
            if (out.length >= limit) return;
            var k = base(b);
            if (seen[k]) return;
            seen[k] = 1;
            var why = key.indexOf('series:') === 0 && num(b) < 999 ? 'Book ' + num(b) : '';
            out.push(card(b, why, true));
          });
          if (!firstWhy && books.length) firstWhy = key;
          return next(i + 1);
        });
      }

      next(0).then(function () {
        if (!out.length) return;
        var sub = firstWhy.indexOf('series:') === 0 ? 'The ' + label(firstWhy) + ' books' : (firstWhy.indexOf('trope:') === 0 ? label(firstWhy) + ' reads' : 'Reads with the same vibe');
        show(box, sub, out);
      }).catch(function () {});
    }

    function init() {
      document.querySelectorAll('.rb-pair[data-mode]').forEach(function (box) {
        if (box.dataset.rbDone) return;
        box.dataset.rbDone = '1';
        if (box.dataset.mode === 'merch') merchForBook(box); else booksForMerch(box);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
